const DatabaseIcon = /*#__PURE__*/ [
  ["ellipse", { cx: "12", cy: "5", rx: "8", ry: "3", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 10.842C7.60158 11.0229 8.27434 11.1718 9 11.282", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20 12C20 13.6569 16.4183 15 12 15C7.58172 15 4 13.6569 4 12", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 17.842C7.60158 18.0229 8.27434 18.1718 9 18.282", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M20 5V19C20 20.6569 16.4183 22 12 22C7.58172 22 4 20.6569 4 19V5", stroke: "currentColor", strokeWidth: "1.5", key: "4" }]
];

export { DatabaseIcon as default };
//# sourceMappingURL=DatabaseIcon.js.map
